import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, Tag, InputGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class NPCEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      npcs: [
        { name: 'NPC_JANGAN_SPECIAL_POTION', title: 'Jangan Special Alchemist', items: 24, currency: 'Gold', status: 'ACTIVE' },
        { name: 'NPC_DONWHANG_AVATAR_STORE', title: 'Donwhang Dress Merchant', items: 56, currency: 'Silk', status: 'ACTIVE' },
        { name: 'NPC_HOTAN_ARENA_VENDOR', title: 'Hotan Battle Arena NPC', items: 18, currency: 'Arena Coins', status: 'ACTIVE' },
        { name: 'NPC_ALEX_COIN_VENDOR', title: 'Alexandria Token Vendor', items: 32, currency: 'Silver/Gold Coins', status: 'ACTIVE' },
        { name: 'NPC_EVENT_SOX_MERCHANT', title: 'SROFilter Event Merchant', items: 12, currency: 'Event Coupons', status: 'ACTIVE' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          NPC Vendor & Custom Shop Editor
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Manage in-game NPC shops, item inventories, currencies (Gold, Silk, Arena Coins), and stock limits.
        </p>

        <Divider className="mb-4" />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="m-0 font-weight-bold" style={{ color: '#182026' }}>Registered Custom NPCs</h5>
          <div style={{ width: '220px' }}>
            <InputGroup leftIcon="search" placeholder="Search NPC Vendor..." value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} small />
          </div>
        </div>

        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>NPC Code Name</th>
              <th style={{ color: '#182026' }}>Shop Title</th>
              <th style={{ color: '#182026' }}>Item Count</th>
              <th style={{ color: '#182026' }}>Accepted Currency</th>
              <th style={{ color: '#182026' }}>Status</th>
              <th style={{ color: '#182026' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {this.state.npcs.map((npc, idx) => (
              <tr key={idx}>
                <td className="font-mono font-weight-bold" style={{ color: '#106ba3' }}>{npc.name}</td>
                <td style={{ color: '#182026' }}>{npc.title}</td>
                <td style={{ color: '#5c7080' }}>{npc.items} Items</td>
                <td className="text-warning font-weight-bold">{npc.currency}</td>
                <td><Tag intent={Intent.SUCCESS} round>{npc.status}</Tag></td>
                <td><Button icon="edit" small minimal intent={Intent.PRIMARY} text="Edit Shop" /></td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
